(ns app.domain.municipality.model
  (:require [app.domain.group.model :as group-model]
            [app.domain.location.model :as location-model]
            [app.i18n.model :as i18n-model]
            [clojure.string :as str]))


(def ^{:arglists '([municipality lang])} municipality-name
  "Get municipality common name"
  (i18n-model/translation-fallback-fn :municipality/names))


(defn subdivision-name
  "Plain language name for a province/state code"
  [tr subdivision]
  (let [arg-vector [(keyword "subdivision" (name subdivision))]]
    (tr arg-vector)))


(defn common-name-province [{:municipality/keys [subdivision] :as municipality} tr lang]
  (if subdivision
    (str (municipality-name municipality lang) ", " (subdivision-name tr subdivision))
    (municipality-name municipality lang)))


(defn local-subdivision-abbreviation [{:municipality/keys [subdivision]}]
  (-> subdivision
      name
      (str/split #"-")
      last))


(defn country-number-string [{:municipality/keys [country number]}]
  (when country
    (str (name country) "-" number)))


(defn municipality-in-scope? [municipality authority-groups]
  (->> authority-groups
       (mapcat group-model/scope-municipalities)
       (map :db/id)
       (some #{(:db/id municipality)})))


(defn center-of-centers
  "Returns the average center coordinate for multiple municipalities"
  [center-coords]
  (when (seq center-coords)
    (let [x-coords (map first center-coords)
          y-coords (map second center-coords)
          min-x    (reduce min x-coords)
          min-y    (reduce min y-coords)
          max-x    (reduce max x-coords)
          max-y    (reduce max y-coords)]
      [(/ (+ min-x max-x) 2)
       (/ (+ min-y max-y) 2)])))

(defn municipality-center-coords
  "Get center coordinates for a municipality"
  [municipality]
  (when-let [center-location (-> municipality :municipality/center-location)]
    (location-model/center-coords-pair-in-epsg-3857 center-location)))
